import { Dialog } from "@headlessui/react";
import React from "react";

/**
 * ui-kit drawers are HeadlessUI dialogs, and a dialog keeps its focus lock and outside-click close until it sees a
 * nested dialog. Nesting is tracked through React context, so a drawer opened from a store never registers with the
 * drawer it visually sits on top of, and the two then fight over focus and close each other. A closed dialog joins
 * that stack without installing a trap of its own, which is enough to demote the surrounding drawer to a parent.
 */
export const DrawerStackAnchor = () => (
    <Dialog static open={false} className="hidden" onClose={() => undefined}>
        <div />
    </Dialog>
);
